import React, { useState } from "react";
import { Button } from "@masterteam/mt-design-react";
import { ReactComponent as DownloadIcon } from "../../assets/images/download.svg";
import { downloadFile } from "../../helpers/attachments";

function DownloadButton({ file, ...otherProps }) {
  const [loading, setLoading] = useState(false);

  const handleDownload = e => {
    e.stopPropagation();
    setLoading(true);
    downloadFile(file).finally(() => setLoading(false));
  };

  return (
    <Button
      Icon={DownloadIcon}
      shape="square"
      variant="primary"
      fill="none"
      {...otherProps}
      onClick={handleDownload}
      loading={loading}
    />
  );
}

export default DownloadButton;
